import { render } from "./EliminatedTeamItem.vue?vue&type=template&id=25c0ff77&scoped=true&bindings={\"team\":\"props\",\"teamName\":\"setup\"}"
import script from "./EliminatedTeamItem.vue?vue&type=script&lang=ts"
export * from "./EliminatedTeamItem.vue?vue&type=script&lang=ts"

import "./EliminatedTeamItem.vue?vue&type=style&index=0&id=25c0ff77&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-25c0ff77"

export default script